import { environment } from '../../environments/environment';

const BASE_URL = environment.api_url;
export const ARTWORK_CONTROLLER_URL = BASE_URL + "/api/algorithms/artwork";
export const SSE_CONTROLLER_URL = BASE_URL + "/api/sse/connection";
// Set REACT_APP_PRINT_FORMAT_API_URL to hit the local runner in the-generative-project-serverless/local instead
export const PRINT_FORMAT_URL = process.env.REACT_APP_PRINT_FORMAT_API_URL || ARTWORK_CONTROLLER_URL + "/printFormat";
export const CHECKOUT_SESSION_URL = process.env.REACT_APP_CHECKOUT_SESSION_API_URL || ARTWORK_CONTROLLER_URL + "/checkoutSession";